export default {
  data () {
    return {
      accessPages: [],
    }

  },

  methods: {
    buildAccessPages() {
      const pages = this.getAccessPages()
      let pagesArray = []

      pages.forEach((page) => {
        let pageConfig = {
          name: page.displayName,
          levels: this.buildPageActions(page)
        }
        pagesArray.push(pageConfig)
      })
      this.accessPages = pagesArray
      this.buildSelectActions()
    },

    buildPageActions(page) {
      const pageTitle = page.abilityName || page.displayName,
          pageActions = ['view', 'edit', 'create']
      let levels = []

      pageActions.forEach((action) => {
        let levelId = `${pageTitle}_${action}`,
            level = { id: levelId, value: this.getBit(levelId.toUpperCase()) }
        levels.push(level)
      })
      return levels
    },

    buildSelectActions() {
      const selectAll = { name: 'select all', levels: [{ id: 'select_all', value: 'all' }] }
      this.accessPages.push(selectAll)
    },

    getAccessPages() {
      const pages = [
        { displayName: 'overview page', abilityName: 'overview' },
        { displayName: 'campaigns' },
        { displayName: 'autoconnects' },
        { displayName: 'insights', abilityName: 'insights' },
        { displayName: 'budz' },
        { displayName: 'feedback' },
        { displayName: 'check-in', abilityName: 'check_in' },
        { displayName: 'customer list', abilityName: 'customer_list' },
        { displayName: 'customer list upload', abilityName: 'customer_upload' },
        { displayName: 'customer profile', abilityName: 'customer_profile' },
        { displayName: 'reports' },
        { displayName: 'logs' },
        { displayName: 'settings' },
        { displayName: 'manage users', abilityName: 'manage_users' },
      ]
      return pages
    },
  },
}
